
import React from "react";
import { Button } from "@/components/ui/button";
import { X } from "lucide-react";

interface ImagePreviewProps {
  previewUrl: string;
  onClear: () => void;
}

export const ImagePreview: React.FC<ImagePreviewProps> = ({
  previewUrl,
  onClear
}) => {
  return (
    <div className="mb-3 relative">
      <div className="flex items-center justify-between mb-2">
        <span className="text-xs text-blue-600 font-medium">Image à analyser:</span>
        <Button
          type="button"
          variant="ghost"
          size="sm"
          className="h-6 w-6 p-0 rounded-full"
          onClick={onClear}
        >
          <X className="h-3.5 w-3.5" />
          <span className="sr-only">Supprimer l'image</span>
        </Button>
      </div>
      <img
        src={previewUrl}
        alt="Preview"
        className="max-h-24 rounded border border-blue-200"
      />
    </div>
  );
};
